import { render, staticRenderFns } from "./ModelBox.vue?vue&type=template&id=7d65610e&scoped=true&"
import script from "./ModelBox.vue?vue&type=script&lang=js&"
export * from "./ModelBox.vue?vue&type=script&lang=js&"
import style0 from "./ModelBox.vue?vue&type=style&index=0&id=7d65610e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d65610e",
  null
  
)

component.options.__file = "ModelBox.vue"
export default component.exports